import { render, staticRenderFns } from "./MfFilterTable.vue?vue&type=template&id=84e0d078&scoped=true&"
import script from "./MfFilterTable.vue?vue&type=script&lang=js&"
export * from "./MfFilterTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e0d078",
  null
  
)

export default component.exports